module.exports = __webpack_public_path__ + "static/45af083390e86aa1978a96c5e40c5f0e.png";